<template>
  <div>
    <hr />

    <DataTable
      :data="citas"
      :columns="[
        { label: 'Fecha',       field: 'fechaCita',
          format: (v) => getFormattedDate(v, 'DD/MM/YYYY') },
        { label: 'Hora',        field: 'horaDesde' },
        { label: 'Estado',      field: 'estadoCita' },
        { label: 'Especialidad',field: 'nombreEspecialidad' },
      ]"
      idField="idCita"
      mensajeVacio="No hay citas registradas."
      :acciones="true"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarBotonNuevo="false"
      @refresh="getData"
    >
      <!-- Acción por fila: ver resumen -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-warning"
          @click="abrirModalEditar(row.idCita)"
          title="Ver resumen"
        >
          <span class="material-icons" style="font-size:14px">info</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal: Resumen de la cita (solo lectura) -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="ventanaModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">event_available</span>
            <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">

              <!-- Id Cita -->
              <div class="col-md-3">
                <label class="form-label small fw-bold">Id Cita</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.idCita" disabled />
              </div>

              <!-- Médico -->
              <div class="col-md-9">
                <label class="form-label small fw-bold">Médico</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.nombreMedico" disabled />
              </div>

              <!-- Especialidad -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Especialidad</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.nombreEspecialidad" disabled />
              </div>

              <!-- Motivo Cita -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Motivo de Cita</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.nombreMotivoCita" disabled />
              </div>

              <!-- Fecha y Estado -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Fecha Cita</label>
                <input type="text" class="form-control bg-light" :value="getFormattedDate(datoCita.fechaCita)" disabled />
              </div>
              <div class="col-md-6">
                <label class="form-label small fw-bold">Estado</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.estadoCita" disabled />
              </div>

              <!-- Hora desde y hasta -->
              <div class="col-md-6">
                <label class="form-label small fw-bold">Hora desde</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.horaDesde" disabled />
              </div>
              <div class="col-md-6">
                <label class="form-label small fw-bold">Hora hasta</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.horaHasta" disabled />
              </div>

              <!-- Descripción -->
              <div class="col-md-12">
                <label class="form-label small fw-bold">Descripción</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.descripcion" disabled />
              </div>

              <!-- Observación -->
              <div class="col-md-12">
                <label class="form-label small fw-bold">Observación</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.observacion" disabled />
              </div>

              <!-- Auditoría -->
              <div class="col-md-3">
                <label class="form-label small fw-bold">Id Usuario Reg.</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.idUsuarioReg" disabled />
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-bold">Fecha Reg.</label>
                <input type="text" class="form-control bg-light" :value="getFormattedDate(datoCita.fechaReg)" disabled />
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-bold">Id Usuario Act.</label>
                <input type="text" class="form-control bg-light" v-model="datoCita.idUsuarioAct" disabled />
              </div>
              <div class="col-md-3">
                <label class="form-label small fw-bold">Fecha Act.</label>
                <input type="text" class="form-control bg-light" :value="getFormattedDate(datoCita.fechaAct)" disabled />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import dateFormat from '@/modules/dateFormat.js';
import api from '@/services/api';
import * as $ from 'jquery';
window['$'] = $;
window['jQuery'] = $;

export default {
  components: { DataTable },

  props: {
    p_idPersona: { type: String, required: true },
  },

  data() {
    return {
      citas:       [],
      datoCita:    {},
      titulo:      '',
      btnEditar:   false,
      modalWindow: true,
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    //  Carga
    async getData() {
      const response = await api.get('/vwcitas/idpersona/' + this.p_idPersona);
      this.citas = response.data.reverse();
    },

    //  Modal
    abrirModalEditar(idCita) {
      this.modalWindow = true;
      if (idCita != null) {
        api.get('/vwcitas/' + idCita).then(resp => {
          this.datoCita = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Resumen de la cita';
      this.btnEditar = true;
    },
  },
};
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>